<template>
  <div>
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="500px">
        <v-card color="grey lighten-5">
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{dialog_baslik}}</v-toolbar-title>
            </v-toolbar>
          </v-flex>
          <v-card-text>
            <v-flex pa-1 xs12 sm12 md12>
              <v-card>
                <v-card color="grey lighten-5" flat="">
                  <v-card-actions>
                    <v-layout wrap>
                      <div class="flex md12">

                        <div v-show="codegorunum === true ">
                          <v-text-field :color="color" :label="$t('Cost-Center-Code')" v-model="Masrafmerkezi.Code"
                            :error-messages="errors.collect('Masrafmerkezi.Code')" v-validate="'required|max:50'"
                            data-vv-name="Masrafmerkezi.Code" required></v-text-field>
                        </div>

                        <v-text-field :color="color" :label="$t('Cost-Center-Name')" v-model="Masrafmerkezi.CodeName"
                          :error-messages="errors.collect('Masrafmerkezi.CodeName')" v-validate="'required|max:250'"
                          data-vv-name="Masrafmerkezi.CodeName" required></v-text-field>
                      </div>
                    </v-layout>

                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>


          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div v-show="m === true">


              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Delete" color="info" slot="activator" @click="deleteExpenceCenter()" flat>
                  <span class="hidden-sm-and-down"> <span class="hidden-sm-and-down"> {{ $t('Delete') }} </span>
                  </span>
                </v-btn>
                <span v-if="!sayfayetki.Delete">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Delete"> {{ $t('Delete') }} </span>
              </v-tooltip>

              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Update" color="info" slot="activator" @click="guncelle()" flat>
                  <span class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{ $t('Update') }}</span>
                  </span>
                </v-btn>
                <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Update">{{ $t('Update') }}</span>
              </v-tooltip>


            </div>
            <div v-show="k === true">
               <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Save" color="info" slot="activator" @click="Kaydet()" flat> <span
                    class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{$t("save_button")}}</span>
                  </span>
                </v-btn>
                <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Save">{{$t("save_button")}}</span>
              </v-tooltip>

            </div>
            <v-btn color="blue darken-1" flat @click.native="dialog = false">{{$t('Cancel')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout row wrap>
      <v-toolbar size="120px" dark color="info">
        <v-toolbar-title> {{ $t('Expense-Center-v2') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field flat="" solo-inverted="" hide-details v-model="search3"  :label="this.$t('Search')" append-icon="search">
        </v-text-field>


      <v-tooltip bottom>
          <v-btn :disabled="!sayfayetki.Save" slot="activator" @click="masrafmerkeziekle()" flat> <span
              class="hidden-sm-and-down"> <span class="hidden-sm-and-down"> {{ $t('Add-v2', { value: $t('Expense-Center-v2')}) }}</span>
            </span>
            <v-icon right dark>add_box</v-icon>

          </v-btn>
          <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
          <span v-if="sayfayetki.Save">{{ $t('Add-v2', { value: $t('Expense-Center-v2')}) }}</span>
        </v-tooltip>




      </v-toolbar>
    </v-layout>


    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>

      </v-card-title>
      <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="items"
        :search="search3">
        <v-progress-linear slot="progress" indeterminate></v-progress-linear>

        <template slot="items" slot-scope="props">
          <tr @click="Getir(props.item.Code)" item>
            <td class="text-xs-left">{{ props.item.Code }}</td>
            <td class="text-xs-left">{{ props.item.CodeName }}</td>
            <td class="text-xs-left">{{ props.item.CompanyCode }}</td>
            <td class="text-xs-left">{{ props.item.Tip }}</td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          {{ $t('No-records-searched-for', { value: search3}) }} 
        </v-alert>
      </v-data-table>
    </v-card>
    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
          :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"

  export default {
    data() {
      return {
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        headers: [{
            text: this.$t('Cost-Center-Code'),
            value: 'CompanyCode'
          },
          {
            text: this.$t('Expense-Center-v2'),
            value: 'CodeName'
          },
          {
            text: this.$t('Company-Code'),
            value: 'Code'
          },
          {
            text: this.$t('Expense-Centre-Type'),
            value: 'Tip'
          }
        ],
        items: [],
        color: 'orange darken-4',
        selected: '',
        search3: '',
        m: false,
        k: false,
        dialog: false,
        Masrafmerkezi: {
          Code: '',
          CodeName: '',
          ExpenseCenterType: null,
          CompanyCode: ''
        },
        dialog_baslik: '',
        codegorunum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        progress: false,
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    mounted() {
      this.$validator.localize('tr', this.dictionary)
      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));


        var params = {
          CompanyCode: credentials.SirketKodu,
        }

        this.progress = true
        this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.items = response.body
          this.progress = false
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
          }
        })

      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          } 

        });

      }
    },
    methods: {
      Getir(v) {
        this.k = false
        this.m = true
        this.codegorunum = false
        this.dialog = true
        this.dialog_baslik = this.$t('Expense-Center')

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));


        var params = {
          CompanyCode: credentials.SirketKodu,
          Code: v
        }
        this.$http.post(auth.API_URL + 'api/ExpenseCenter/Get', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.Masrafmerkezi = response.body[0]
        })
      },
      deleteExpenceCenter: deleteExpenceCenter,
      masrafmerkeziekle: masrafmerkeziekle,
      Kaydet: Kaydet,
      guncelle: guncelle,
    },
    beforeMount: beforeMount,
    components: {
      yetkidialog
    },
  }

  function Kaydet() {
    this.$validator.validateAll().then((result) => {
      if (result) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));


        var params1 = {
          CompanyCode: credentials.SirketKodu,
        }

        this.Masrafmerkezi.CompanyCode = credentials.SirketKodu

        var params = this.Masrafmerkezi

        this.$http.post(auth.API_URL + 'api/ExpenseCenter/New', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status==false) {
             
               this.text1 = this.$t(response.body.ResponseMessage)
              this.snackbar = true
              return;
          }
          if (response.body.Status) {
            this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              
              this.items = response.body
              this.dialog = false
              this.text1 = 'Kayıt işlemi tamamlandı.'
              this.snackbar = true
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              }
            })

          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })
      }
    })
  }


  function masrafmerkeziekle() {
    this.$validator.reset()
    this.dialog = true
    this.Masrafmerkezi.Code = ''
    this.Masrafmerkezi.CodeName = ''
    this.dialog_baslik = this.$t('Expense-Center')
    this.m = false
    this.k = true
    this.codegorunum = true
  }

  function beforeMount() {


  }

  function deleteExpenceCenter() {
    if (window.confirm('Masraf Merkezin\'i silmek istediğinizden emin misiniz?')) {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));



      var params1 = {
        CompanyCode: credentials.SirketKodu,
      }
      this.Masrafmerkezi.CompanyCode = credentials.SirketKodu
      var params = this.Masrafmerkezi
      this.$http.post(auth.API_URL + 'api/ExpenseCenter/Delete', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        if (response.body.Status) {
          this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params1, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.items = response.body
            this.dialog = false
            this.text = 'Silme işlemi tamamlandı'
            this.snackbar = true

          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            }
          })
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        }
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        }
      })
    }
  }

  function guncelle() {
    this.$validator.validateAll().then((result) => {
      if (result) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var params1 = {
          CompanyCode: credentials.SirketKodu
        }

        this.Masrafmerkezi.CompanyCode = credentials.SirketKodu
        var params = this.Masrafmerkezi
        this.codegorunum = false
        this.$http.post(auth.API_URL + 'api/ExpenseCenter/Update', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status) {
            this.text1 = this.$t('Update-completed')
            this.snackbar = true
            this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.items = response.body
              this.dialog = false
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text1 = response.statusText
                this.snackbar = true
              }
            })
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = response.statusText
            this.snackbar = true
          }
        })
      }
    })
  }
</script>

<style>
</style>